import DataTable, { TableStyles } from 'react-data-table-component';
import WF_4_7_1_AlertHistoryExpandableComponent from './detail/WF_4_7_1_AlertHistoryExpandableComponent';
import Button from '../../common/button/Button';
import { useWfAlertHistoryStore } from 'src/api/wf/stores/WfAlertHistoryStore';
import { getAlertHistoryRecordColumns } from './columns';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useWfAlertHistoryService from 'src/api/wf/service/WfAlertHistoryService';
import { useEffect } from 'react';
import P_CollapsibleSection from '../common/collapsibleSection/P_CollapsibleSection';
import { FormRow } from '../../common/form/FormRow';

const customStyles: TableStyles = {
  table: {
    style: {
      tableLayout: 'fixed',
      width: '100%',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#FFD700',
      color: '#000',
      fontWeight: 'bold',
      border: '1px solid #ccc',
    },
  },
  cells: {
    style: {
      border: '1px solid #ccc',
    },
  },
  rows: {
    style: {
      borderBottom: '1px solid #ccc',
    },
  },
};

const toDisplayText = (value?: string | null) => {
  if (value === null || value === undefined) return '';

  const trimmed = value.trim();
  if (trimmed === '' || trimmed === 'null') return '';

  return trimmed;
};

function WF_4_7_1_AlertHistory() {
  const { t } = useTranslation();
  const { fetchHistory } = useWfAlertHistoryService();
  const { history, historySearchParams, selectedHistory } = useWfAlertHistoryStore();
  const navigate = useNavigate();

  const handleBackButton = () => {
    navigate(-1);
  };

  useEffect(() => {
    const loadHistory = async () => {
      try {
        await fetchHistory();
      } catch (error) {
        console.error('Failed to fetch history:', error);
      }
    };
    loadHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex-1 flex-col p-4">
      <P_CollapsibleSection
        title={t('wf.alertHistory.workplaceInfo')}
        className="mt-4 pb-2"
        contentClassName="grid grid-cols-1 md:grid-cols-2 gap-x-4"
      >
        <FormRow title={t('wf.alertHistory.buildingName')}>
          <p className="text-sm">{toDisplayText(historySearchParams?.buildingName)}</p>
        </FormRow>
        <FormRow title={t('wf.alertHistory.organizationCode')}>
          <p className="text-sm">{toDisplayText(historySearchParams?.organizationCode)}</p>
        </FormRow>
        <FormRow title={t('wf.alertHistory.salesOfficeCode')}>
          <p className="text-sm">{toDisplayText(historySearchParams?.branchCode)}</p>
        </FormRow>
        <FormRow title={t('wf.common.customerNumber')}>
          <p className="text-sm">{toDisplayText(historySearchParams?.customerNumber)}</p>
        </FormRow>
      </P_CollapsibleSection>
      <P_CollapsibleSection
        title={t('wf.alertHistory.alertHistoryInfo')}
        contentClassName="flex-1 overflow-y-auto"
      >
        <DataTable
          noDataComponent={t('wf.common.noResults')}
          columns={getAlertHistoryRecordColumns(t)}
          data={history?.alertHistoryRecords ?? []}
          customStyles={customStyles}
          expandableRows
          expandableRowsComponent={WF_4_7_1_AlertHistoryExpandableComponent}
          expandableRowExpanded={(row) => row.alertHistoryId === selectedHistory?.alertHistoryId}
        />
      </P_CollapsibleSection>

      <div className="mt-4 flex justify-end">
        <Button title={t('wf.common.back')} onClick={handleBackButton} />
      </div>
    </div>
  );
}

export default WF_4_7_1_AlertHistory;
